/**
 * Data layer for `enterprise-plan-unlock-csm-custom-slas-ssl-on-domain-custom-data-residency`. Thin typed fetch wrappers over /api/v1/enterprise-plan-unlock-csm-custom-slas-ssl-on-domain-custom-data-residency.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface EnterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListEnterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyResponse {
	count: number;
	items: EnterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyRow[];
}

export interface CreateEnterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/enterprise-plan-unlock-csm-custom-slas-ssl-on-domain-custom-data-residency";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListEnterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListEnterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyResponse>(res);
}

export async function create(body: CreateEnterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyBody): Promise<EnterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<EnterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const enterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyQueryKeys = {
	all: ["enterprise-plan-unlock-csm-custom-slas-ssl-on-domain-custom-data-residency"] as const,
	list: () => [...enterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyQueryKeys.all] as const,
	detail: (id: string) => [...enterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyQueryKeys.all, id] as const,
};
